"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f113 = void 0;
exports.f113 = {
    "qu": [
        "Latn"
    ],
    "qua": [
        "Latn"
    ],
    "qub": [
        "Latn"
    ],
    "quc": [
        "Latn"
    ],
    "qud": [
        "Latn"
    ],
    "quf": [
        "Latn"
    ],
    "qug": [
        "Latn"
    ],
    "qui": [
        "Latn"
    ],
    "quk": [
        "Latn"
    ],
    "qul": [
        "Latn"
    ],
    "qum": [
        "Latn"
    ],
    "qun": [
        "Latn"
    ],
    "qup": [
        "Latn"
    ],
    "quq": [
        "Latn"
    ],
    "qur": [
        "Latn"
    ],
    "qus": [
        "Latn"
    ],
    "quv": [
        "Latn"
    ],
    "quw": [
        "Latn"
    ],
    "qux": [
        "Latn"
    ],
    "quy": [
        "Latn"
    ],
    "qva": [
        "Latn"
    ],
    "qvc": [
        "Latn"
    ],
    "qve": [
        "Latn"
    ],
    "qvh": [
        "Latn"
    ],
    "qvi": [
        "Latn"
    ],
    "qvj": [
        "Latn"
    ],
    "qvl": [
        "Latn"
    ],
    "qvm": [
        "Latn"
    ],
    "qvn": [
        "Latn"
    ],
    "qvo": [
        "Latn"
    ],
    "qvp": [
        "Latn"
    ],
    "qvs": [
        "Latn"
    ],
    "qvw": [
        "Latn"
    ],
    "qvy": [
        "Zyyy"
    ],
    "qvz": [
        "Latn"
    ],
    "qwa": [
        "Latn"
    ],
    "qwc": [
        "Latn"
    ],
    "qwh": [
        "Latn"
    ],
    "qwm": [
        "Cyrl"
    ],
    "qws": [
        "Latn"
    ],
    "qwt": [
        "Zyyy"
    ],
    "qxa": [
        "Latn"
    ],
    "qxc": [
        "Latn"
    ],
    "qxh": [
        "Latn"
    ],
    "qxl": [
        "Latn"
    ],
    "qxn": [
        "Latn"
    ],
    "qxo": [
        "Latn"
    ],
    "qxp": [
        "Latn"
    ],
    "qxq": [
        "Arab"
    ],
    "qxr": [
        "Latn"
    ],
    "qxs": [
        "Zyyy"
    ],
    "qxt": [
        "Latn"
    ],
    "qxu": [
        "Latn"
    ],
    "qxw": [
        "Latn"
    ],
    "qya": [
        "Latn",
        "Cirt",
        "Sara",
        "Teng"
    ],
    "qyp": [
        "Latn"
    ],
    "qaa": [
        "Latn"
    ]
};
